// Copyright (c) Ping. All rights reserved.

import React from 'react';
import {
  StyleSheet,
  Text,
  type TextStyle,
  View,
  type ViewStyle,
} from 'react-native';
import { useColorScheme } from '../../foundations/colorScheme';
import { createTheme } from '../../design-system/theme';
import { notesStrings } from './strings';

export interface NotesEmptyStateProps {
  readonly query: string;
}

export const NotesEmptyState = React.memo<NotesEmptyStateProps>(({ query }) => {
  const scheme = useColorScheme();
  const theme = createTheme(scheme === 'dark' ? 'dark' : 'light');

  return (
    <View style={[styles.container, { backgroundColor: theme.colors.surface.primary }]}>
      <Text style={[styles.title, { color: theme.colors.text.primary }]}>
        {notesStrings.emptyTitle(query)}
      </Text>
      <Text style={[styles.body, { color: theme.colors.text.secondary }]}>
        {notesStrings.emptyBody}
      </Text>
    </View>
  );
});

NotesEmptyState.displayName = 'NotesEmptyState';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  } satisfies ViewStyle,
  title: {
    fontSize: 17,
    fontWeight: '600',
    marginBottom: 6,
    textAlign: 'center',
  } satisfies TextStyle,
  body: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
    maxWidth: 320,
  } satisfies TextStyle,
});
